import Vue from 'vue';
import Router from 'vue-router';
import Cookies from 'js-cookie';

// VIP 頁面
const Index = () => import(/* webpackChunkName: "Vip" */ '@/views/VIP/Index');
const Profile = () => import(/* webpackChunkName: "Vip" */ '@/views/VIP/Profile');
const Brand = () => import(/* webpackChunkName: "Vip" */ '@/views/VIP/Brand');
const Coupon = () => import(/* webpackChunkName: "Coupon" */ '@/views/VIP/Coupon');
const Coupons = () => import(/* webpackChunkName: "Coupon" */ '@/views/VIP/Coupons');
const Points = () => import(/* webpackChunkName: "Points" */ '@/views/VIP/Points');
const Point = () => import(/* webpackChunkName: "Points" */ '@/views/VIP/Point');
const PointStock = () => import(/* webpackChunkName: "Points" */ '@/views/VIP/Stock');
const Reward = () => import(/* webpackChunkName: "Points" */ '@/views/VIP/Reward');
const News = () => import(/* webpackChunkName: "News" */ '@/views/VIP/News');
const Transactions = () => import(/* webpackChunkName: "Transactions" */ '@/views/VIP/Transactions');
const Gifts = () => import(/* webpackChunkName: "Gifts" */ '@/views/VIP/Gifts');

// 入口頁面
const Entry = () => import(/* webpackChunkName: "Entry" */ '@/views/Entry');

// 領取點數
const Claim = () => import(/* webpackChunkName: "Claim" */ '@/views/Event/Claim');

// 修改 Ocard 個人檔案
const Edit = () => import(/* webpackChunkName: "Vip" */ '@/views/Edit');

// 嚐鮮券
const TrialCoupon = () => import(/* webpackChunkName: "TrialCoupon" */ '@/views/Event/TrialCoupon');

// 抽獎
const Draw = () => import(/* webpackChunkName: "Draw" */ '@/views/Draw');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  linkExactActiveClass: 'is-exact-active',
  linkActiveClass: 'is-active',
  routes: [
    // 入口頁面
    {
      path: '/vip/:brand/entry',
      alias: [
        '/member/:brand/entry',
        '/bot/:brand/entry',
        '/mvip/:brand/entry',
        '/vp-:key/:brand/entry',
      ],
      name: 'Entry',
      component: Entry,
    },

    // VIP 頁面
    {
      path: '/vip/:brand',
      alias: [
        '/member/:brand',
        '/bot/:brand',
        '/mvip/:brand',
        '/vp-:key/:brand',
      ],
      component: Index,
      children: [
        {
          path: '',
          name: 'Index',
          component: Profile,

        },
        { path: 'b', redirect: 'brand' },
        {
          path: 'brand',
          name: 'Brand',
          component: Brand,
        },
        { path: 'c', redirect: 'coupons' },
        {
          path: 'coupons',
          alias: 'c',
          name: 'Coupons',
          component: Coupons,
        },
        { path: 'p', redirect: 'points' },
        {
          path: 'points',
          name: 'Points',
          component: Points,
        },
      ],
    },
    {
      path: '/vip/c/:token?',
      alias: [
        '/member/c/:token?',
        '/bot/c/:token?',
        '/mvip/c/:token?',
        '/vp-:key/c/:token?',
      ],
      redirect: '/vip/coupon/:token?',
    },
    {
      path: '/vip/:brand/coupon/:token?',
      alias: [
        '/member/:brand/coupon/:token?',
        '/bot/:brand/coupon/:token?',
        '/mvip/:brand/coupon/:token?',
        '/vp-:key/:brand/coupon/:token?',
      ],
      name: 'Coupon',
      component: Coupon,
    },
    {
      path: '/vip/:brand/point/:token?',
      alias: [
        '/member/:brand/point/:token?',
        '/bot/:brand/point/:token?',
        '/mvip/:brand/point/:token?',
        '/vp-:key/:brand/point/:token?',
      ],
      name: 'Point',
      component: Point,
    },
    {
      path: '/vip/:brand/point/:token/stock',
      name: 'PointStock',
      component: PointStock,
    },
    {
      path: '/vip/:brand/point/:pointToken/reward/:token?',
      alias: [
        '/member/:brand/point/:pointToken/reward/:token?',
        '/bot/:brand/point/:pointToken/reward/:token?',
        '/mvip/:brand/point/:pointToken/reward/:token?',
        '/vp-:key/:brand/point/:pointToken/reward/:token?',
      ],
      name: 'Reward',
      component: Reward,
    },
    {
      path: '/vip/:brand/news/:token?',
      alias: [
        '/member/:brand/news/:token?',
        '/bot/:brand/news/:token?',
        '/mvip/:brand/news/:token?',
        '/vp-:key/:brand/news/:token?',
      ],
      name: 'News',
      component: News,
    },
    {
      path: '/vip/:brand/transactions',
      alias: [
        '/member/:brand/transactions',
        '/bot/:brand/transactions',
        '/mvip/:brand/transactions',
        '/vp-:key/:brand/transactions',
      ],
      name: 'Transactions',
      component: Transactions,
    },

    // 修改 Ocard 個人檔案
    {
      path: '/vip/:brand/profile/edit',
      alias: [
        '/member/:brand/profile/edit',
        '/bot/:brand/profile/edit',
        '/mvip/:brand/profile/edit',
        '/vp-:key/:brand/profile/edit',
      ],
      name: 'Edit',
      component: Edit,
    },

    // 禮物盒
    {
      path: '/vip/:brand/gifts',
      alias: [
        '/member/:brand/gifts',
        '/bot/:brand/gifts',
        '/mvip/:brand/gifts',
        '/vp-:key/:brand/gifts',
      ],
      name: 'Gifts',
      component: Gifts,
    },

    // 領取點數
    {
      path: '/points/claim',
      name: 'Claim',
      component: Claim,
    },

    // 嚐鮮券
    {
      path: '/trial-coupon/:token?',
      alias: '/tc/:token?',
      name: 'TrialCoupon',
      component: TrialCoupon,
    },

    // 抽獎
    {
      path: '/draw/:token/:serial?',
      name: 'Draw',
      component: Draw,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.query.s) {
    if (!to.params.brand) next();
    if (process.env.NODE_ENV === 'development') {
      Cookies.set(`s_${to.params.brand}`, to.query.s);
    } else {
      Cookies.set(`s_${to.params.brand}`, to.query.s, { domain: '.ocard.co' });
    }
    const newTo = to;
    delete newTo.query.s;
    next(newTo);
  }
  next();
});

export default router;
